<script lang="ts">
  import SolidReviewCard from 'src/components/solid-review-card.svelte';
  import type { BusinessReviewEntry } from 'src/function-utils/data-models';
  export let reviews: BusinessReviewEntry[];
  export let businessKey: string;
  export let isCelebrity: boolean = false;
  export let width: number = 0;
</script>

<div
  role="list"
  class={`marqueeList ${$$restProps.class}`}
  bind:clientWidth={width}
>
  {#each reviews as review}
    <div role="listitem">
      <SolidReviewCard {review} {isCelebrity} {businessKey} />
    </div>
  {/each}
</div>

<style lang="scss">
  .marqueeList {
    display: grid;
    grid-auto-columns: 350px;
    grid-auto-flow: column;
    gap: 8px;
  }
</style>
